const styles = {
  root: {
    marginTop: '10px',
    marginBottom: '10px'
  }
};

export default styles;
